import * as type from './types';
import axios from '../../../common/config/axios';

export const getWallet = () => dispatch => {
    axios.get('wallet/get')
    .then((response) => {
        dispatch({
            type: type.GET_WALLET,
            payload: response.data
        });
    }).catch(err => {
        // console.warn(err);
    });
};